function calculateTotalPackagePrice(packagePrice: number, numberOfGuest: number): number {

  if (numberOfGuest <= 0) {
    throw new Error("Number of guests must be greater than 0.");
  }
  const totalPrice = packagePrice * numberOfGuest;
  let discount = 0;
  const currentDate = new Date();
  const blackFridayEndDate = new Date("2025-12-02T23:59:59");

  if (process.env.REACT_APP_PROJECT_COUNTRY === "uk") {
    // Black Friday discount: £200 per booking if booked before end of Tuesday 2nd December 2025
    // Minimum spend: £5,000
    // if (currentDate <= blackFridayEndDate && totalPrice >= 5000) {
    //   discount = 200;
    // }

    // if (currentDate < cutoffDate) {
    // Discount applied until Feb 28, 2025
    // if (totalPrice >= 10000) {
    //   discount = 400;
    // } else if (totalPrice >= 7500) {
    //   discount = 300;
    // if (totalPrice >= 6000) {
    //   discount = 200;
    // } else if (totalPrice >= 5000) {
    //   discount = 150;
    // }
    // // below 5000 discount is 100 on TOTAL PACKAGE price
    // else if (totalPrice < 5000) {
    //   discount = 100;
    // }
    // else if (totalPrice >= 2000) {
    //   discount = 50;
    // }
    // } 

    //  else {
    // Standard discount
    discount = 100;
    // }
  }

  else if (`${process.env.REACT_APP_PROJECT_COUNTRY}` === "ie") {
    // Black Friday discount: £200 per booking if booked before end of Tuesday 2nd December 2025
    // Minimum spend: £5,000
    // if (currentDate <= blackFridayEndDate && totalPrice >= 5000) {
    //   discount = 200;
    // }

    // if (totalPrice >= 6000) {
    //   discount = 200;
    // } else if (totalPrice >= 5000) {
    //   discount = 150;
    // }
    // // below 5000 discount is 100 on each person
    // else if (totalPrice < 5000) {
    //   discount = 100;
    // }
    // else if (totalPrice >= 4000) {
    //   discount = 150;
    // }
    // else if (totalPrice >= 3000) {
    //   discount = 100;
    // }
    // else if (totalPrice >= 2000) {
    //   discount = 50;
    // }
    //  else {
    //   // Standard discount
    discount = 100;
    // }
  }
  return totalPrice - discount;

}

export function calculatePerPersonPrice(packagePrice: number, numberOfGuest: number): number {
  if (numberOfGuest <= 0) {
    throw new Error("Number of guests must be greater than 0.");
  }

  // Calculate total price after discount
  const totalPriceAfterDiscount = calculateTotalPackagePrice(packagePrice, numberOfGuest);

  // Calculate per-person price
  const perPersonPrice = totalPriceAfterDiscount / numberOfGuest;

  return perPersonPrice;
}
